const LEGACY_CACHE_PREFIX = 'vaerion-';

export async function retireLegacyServiceWorkers(): Promise<void> {
  const cleanupTasks: Promise<unknown>[] = [];

  if (typeof navigator !== 'undefined' && navigator.serviceWorker?.getRegistrations) {
    cleanupTasks.push(
      navigator.serviceWorker.getRegistrations()
        .then((registrations) =>
          Promise.allSettled(registrations.map((registration) => registration.unregister())),
        ),
    );
  }

  if (typeof caches !== 'undefined' && caches.keys && caches.delete) {
    cleanupTasks.push(
      caches.keys()
        .then((cacheKeys) =>
          Promise.allSettled(
            cacheKeys
              .filter((cacheKey) => cacheKey.startsWith(LEGACY_CACHE_PREFIX))
              .map((cacheKey) => caches.delete(cacheKey)),
          ),
        ),
    );
  }

  if (!cleanupTasks.length) {
    return;
  }

  await Promise.allSettled(cleanupTasks);
}
